import { stageToBlobAsync } from '@hts/shared/utils';
import Konva from 'konva';
import { useCallback, useMemo, useRef } from 'react';
import { LiveView } from '../../components';
import { INewCardState } from '../../types';
import { getMainImageSizes } from '../../utils';

interface IUseExportLiveViewProps {
  card: INewCardState | null;
}

export const useExportLiveView = ({ card }: IUseExportLiveViewProps) => {
  const stageRef = useRef<Konva.Stage | null>(null);
  const containerRef = useRef<HTMLDivElement>(null);

  const cardDimensions = getMainImageSizes(
    card?.imageDimensions,
    card?.previewUrl?.image || undefined
  );

  const getStageBlob = useCallback(async () => {
    const stage = stageRef.current;

    const { width, height } = cardDimensions;

    if (!stage || !width || !height) return null;

    const stareWidth = stage.width();
    const stageHeight = stage.height();
    const pixelRatio = Math.max(width / stareWidth, height / stageHeight);

    return await stageToBlobAsync(stage, pixelRatio);
  }, [cardDimensions]);

  const renderExportLiveView = useMemo(
    () => (
      <div
        ref={containerRef}
        style={{
          display: 'flex',
          visibility: 'hidden',
          position: 'fixed',
          zIndex: -1,
          width: 300,
          height: 300,
          top: 0,
          left: 0,
        }}
      >
        <LiveView
          ref={stageRef}
          containerRef={containerRef}
          isForExport={true}
          activeTextFieldId={null}
        />
      </div>
    ),
    []
  );

  return {
    renderExportLiveView,
    getStageBlob,
  };
};
